export const US_STATES = {
  Alabama: ["Alabama", "AL"],
  Alaska: ["Alaska", "AK"],
  Arizona: ["Arizona", "AZ"],
  Arkansas: ["Arkansas", "AR"],
  California: ["California", "CA"],
  Colorado: ["Colorado", "CO"],
  Connecticut: ["Connecticut", "CT"],
  Delaware: ["Delaware", "DE"],
  "District of Columbia": ["District of Columbia", "DC"],
  Florida: ["Florida", "FL"],
  Georgia: ["Georgia", "GA"],
  Hawaii: ["Hawaii", "HI"],
  Idaho: ["Idaho", "ID"],
  Illinois: ["Illinois", "IL"],
  Indiana: ["Indiana", "IN"],
  Iowa: ["Iowa", "IA"],
  Kansas: ["Kansas", "KS"],
  Kentucky: ["Kentucky", "KY"],
  Louisiana: ["Louisiana", "LA"],
  Maine: ["Maine", "ME"],
  Maryland: ["Maryland", "MD"],
  Massachusetts: ["Massachusetts", "MA"],
  Michigan: ["Michigan", "MI"],
  Minnesota: ["Minnesota", "MN"],
  Mississippi: ["Mississippi", "MS"],
  Missouri: ["Missouri", "MO"],
  Montana: ["Montana", "MT"],
  Nebraska: ["Nebraska", "NE"],
  Nevada: ["Nevada", "NV"],
  "New Hampshire": ["New Hampshire", "NH"],
  "New Jersey": ["New Jersey", "NJ"],
  "New Mexico": ["New Mexico", "NM"],
  "New York": ["New York", "NY"],
  "North Carolina": ["North Carolina", "NC"],
  "North Dakota": ["North Dakota", "ND"],
  Ohio: ["Ohio", "OH"],
  Oklahoma: ["Oklahoma", "OK"],
  Oregon: ["Oregon", "OR"],
  Pennsylvania: ["Pennsylvania", "PA"],
  "Rhode Island": ["Rhode Island", "RI"],
  "South Carolina": ["South Carolina", "SC"],
  "South Dakota": ["South Dakota", "SD"],
  Tennessee: ["Tennessee", "TN"],
  Texas: ["Texas", "TX"],
  Utah: ["Utah", "UT"],
  Vermont: ["Vermont", "VT"],
  Virginia: ["Virginia", "VA"],
  Washington: ["Washington", "WA"],
  "West Virginia": ["West Virginia", "WV"],
  Wisconsin: ["Wisconsin", "WI"],
  Wyoming: ["Wyoming", "WY"],
};
